import script from "./PostPreviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PostPreviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./PostPreviewComponent.vue?vue&type=style&index=0&id=6ee8070e&lang=scss"
import "./PostPreviewComponent.vue?vue&type=style&index=1&id=6ee8070e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee8070e"]])

export default __exports__